'use strict';

var _ = require('lodash');

var DEFAULT_STYLE_PARAMS = {
  backgroundColor: 'bg',
  borderColor: 'brd',
  borderWidth: 'brw',
  borderRadius: 'rd',
  color: 'txt'
};

var STYLE_PARAMS_OVERRIDES = {
  'wysiwyg.viewer.components.inputs.FileUploader': {
    backgroundColor: 'btn_bg',
    borderColor: 'btn_brd',
    borderWidth: 'btn_brw',
    borderRadius: 'btn_rd',
    color: 'btn_txt'
  }
};

function convertStyleParamForViewerType(viewerType, styleParam) {
  var overrides = _.get(STYLE_PARAMS_OVERRIDES, viewerType);
  var styleParamMap = overrides ? overrides : DEFAULT_STYLE_PARAMS;
  return _.get(styleParamMap, styleParam);
}

module.exports = {
  convertStyleParamForViewerType: convertStyleParamForViewerType
};


// WEBPACK FOOTER //
// ./~/santa-platform-utils/lib/widgetUtils.js